export default "__VITE_ASSET__d9a5abd2__"